// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SafeDictionary } from "@insite/client-framework/Common/Types";
import {
    createHandlerChainRunner,
    executeAwaitableHandlerChain,
    Handler,
} from "@insite/client-framework/HandlerCreator";
import displayProductsVariantChildren from "@west/App/Handlers/ProductList/DisplayProductsVariantChildren";
import { getProductListVariantChildrenDataView } from "@west/App/Store/Selectors/ProductListSelectors";

type Parameter = {
    needToLoadChildren?: boolean;
    parentProductId: string;
    variantSelection: SafeDictionary<string>;
};

type Props = {};

type HandlerType = Handler<Parameter, Props>;

const ShouldLoadVariantProducts: HandlerType = async props => {
    const shouldLoadVariantChildren =
        props.parameter.needToLoadChildren &&
        !getProductListVariantChildrenDataView(props.getState(), props.parameter.parentProductId);

    if (shouldLoadVariantChildren) {
        await executeAwaitableHandlerChain(
            displayProductsVariantChildren,
            {
                parentProductId: props.parameter.parentProductId,
            },
            props,
        );
    }
};

const UpdateVariantSelection: HandlerType = props => {
    props.dispatch({
        type: "xProductListVariantSelection/UpdateVariantSelection",
        variantSelection: props.parameter.variantSelection,
        parentProductId: props.parameter.parentProductId,
    } as any);
};

export const chain = [ShouldLoadVariantProducts, UpdateVariantSelection];

const updateProductListVariantSelection = createHandlerChainRunner(chain, "UpdateProductListVariantSelection");
export default updateProductListVariantSelection;
